module.exports = __webpack_public_path__ + "static/wings_of_flying-c1b32fd288867bd34c29685a99b96725.jpeg";